// extracted by mini-css-extract-plugin
module.exports = {"subscribe-address":"a10a3f92e9--subscribe-address--DbNiK"};